export enum EMBEDDING {
  DATA_COLLECTED = 'dataCollected',
  DATA_PROTECTION_OFFICER = 'dataProtectionOfficer',
  DATA_PURPOSES = 'dataPurposes',
  DATA_RECIPIENTS = 'dataRecipients',
  DESCRIPTION = 'description',
  FURTHER_INFORMATION = 'furtherInformation',
  LEGAL_BASIS = 'legalBasis',
  OPT_IN_CHECKBOX_WITH_LABEL = 'optInCheckboxWithLabel',
  PROCESSING_LOCATION = 'processingLocation',
  PROCESSOR_NAMES = 'processorNames',
  RETENTION_PERIOD = 'retentionPeriod',
  TECHNOLOGIES_USED = 'technologiesUsed',
  THIRD_COUNTRY_TRANSFER = 'thirdCountryTransfer',
}
